import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

// I18N
import { useTranslation } from "react-i18next";
import Logo from "../../assets/images/logos/logo.png";

export default function ReportHeaderMonthly() {
  const { t } = useTranslation("common");

  return (
    <>
      <Grid container>
        <Grid xs={12} item>
          <Box style={{ display: "flex", justifyContent: "center" }}>
            <img className="report-logo" src={Logo} alt="Imagem" />
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        <Grid xs={12} item>
          <Box style={{ display: "flex", justifyContent: "center" }} className="text-cnpj">
            CNPJ 57.456.341/0001-93
          </Box>
        </Grid>
      </Grid>
      <Grid container>
        <Grid xs={12} item>
          <Box style={{ display: "flex", justifyContent: "center" }} className="text-title">
            {t("reports.title_monthly")}
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
